
<template>
    <div class="">
		<div class="ta-right cl-gray">{{thead}}</div>
        <div v-if="list.length>0">
            <router-link v-for="(item,index) in list" :key="index" class="rank-item--a" :to="{name:'others',query:{uid:item.userInfo['uid']}}" >
                <van-row type="flex" align="center">
                    <van-col span="4" class="ta-center"><span :class="rankClass(index)">{{index>2?(index+1):''}}</span></van-col>
                    <van-col span="12">
                        <div class="ta-left">
                            <k-user :logo="item.userInfo['logo'].thumb50" :nick="item.userInfo['nick']"></k-user>
                        </div>
                    </van-col>
                    <van-col span="8" class="ta-right">
                        <k-num :value="lastData(item)"></k-num>
                    </van-col>
                </van-row>
            </router-link>
        </div>
        <k-no-data v-else></k-no-data>
    </div>
</template>
<script>
export default {
    props : ['list', 'thead', 'type'],
    computed: {
        
    },
    methods: {
        rankClass(index){
            return index < 3 ? ('sort-' + index) : ''
        },
        lastData(item){
            const {type} = this
            if(type === 'win'){
                return item.historyUnbrokenMaxWin
            } else {
                return item.totalIncome
            }
        }
    },
    watch: {
        list(n){
            console.log(n)
        }
    },
}
</script>